import { cn } from '@/lib/utils.ts';

const DangerIconButton = ({
  children,
  className,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <button
      type="button"
      aria-label="Remove"
      className={cn(
        'rounded-md p-[7px] transition hover:bg-error-100 [&>svg]:size-5 [&>svg]:text-error-200',
        'disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
};

export default DangerIconButton;
